export default __webpack_public_path__ + "static/media/bookMeetingBanner.acd36d78.png";